export const DashboardUrls = {
  Submissions: "/shell/dashboard/submissions/forms",
  SubmissionDetail: "/shell/dashboard/submissions/forms/detail",
  Upstream: "/shell/dashboard/submissions/upstream",
  Secretariat: "/shell/dashboard/submissions/secretariat",
  ResultsOverview: "/shell/dashboard/results-overview",
};
export const MemberUrls = {
  List: "/shell/member/list",
  Profile: "/shell/member/profile",
  AddMultiple: "/shell/member/add",
};
export const UpstreamUrls = {
  List: "/shell/upstream/list",
  Profile: "/shell/upstream/profile",
};
export const AuthUrls = {
  Logout: "/auth/logout",
};
export const AccountUrls = {
  ManageMyProfile: "/shell/account/profile/me",
  Profile: "/shell/account/profile",
  ManageUsers: "/shell/account/list",
};
export const SettingsUrls = {
  AdminFormsAndCycle: "/shell/admin/form-and-cycle",
};

export const EDIT_URL_PATTERN = "/edit?";
export const ME_EDIT_URL_PATTERN = "/me/edit";
